<template>
  <div>测试跳转</div>
</template>

<script>
import api from '../api/user/index.js';

export default {
  created() {
    this.thirdQueryUserInfo();
  },
  methods: {
    async thirdQueryUserInfo() {
      const { siteId } = this.$route.query;
      const { data } = await api.createEncryptionParam({
        siteId,
      });
      const thirdQUrl = 'http://api.lims.slyt.sinopec.com/css/v1/auth/login';

      if (data) {
        // 跳转到第三方页面
        window.location.href = `${thirdQUrl}?${data}`;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
